module.exports = __webpack_public_path__ + "static/media/location.08e9e0e7.svg";